import React from 'react';

import EditForm from './EditForm';
import FormLoader from '../shared/forms/FormLoader';
import PropTypes from 'prop-types';

const SalesAppointmentEditor = ({
    cancelEdit,
    customerId,
    editId,
    fetchData,
    scheduleOverride
}) => {
    const getUrl = `/api/calendar/sales/edit/${editId}?customerId=${customerId}`;
    const postUrl = `/api/calendar/sales/edit`;

    const schedule = scheduleOverride || ((editView) =>
    window.location = `/calendar/scheduleSalesAppointment/${editView.item.id}`);

    return (
        <FormLoader
            cancelEdit={cancelEdit}
            fetchData={fetchData}
            loadForm={editId !== undefined}
            getUrl={getUrl}
            postUrl={postUrl}
            validator={salesAppointmentValidator}
        >
            <EditForm cancelEdit={cancelEdit} editId={editId} schedule={schedule}/>
        </FormLoader>
    );
}

SalesAppointmentEditor.propTypes = {
    cancelEdit: PropTypes.func,
    customerId: PropTypes.number,
    editId: PropTypes.number,
    fetchData: PropTypes.func
};

export default SalesAppointmentEditor;

const salesAppointmentValidator = (data) => {
    const areas = [...data.areasInterestedIn];
    data.areasInterestedIn = areas.filter(a => {
        if (a.areaTypeId !== 0) {
            return a;
        }
    });
    return [true, data];
}